import moment from 'moment'

// To test different timezones localy uncomment any of the lines below

// moment.tz.setDefault('UTC')
// moment.tz.setDefault('Europe/London')
// moment.tz.setDefault('Europe/Warsaw')
// moment.tz.setDefault('US/Eastern')

export default moment
